module.exports = __webpack_public_path__ + "static/media/lock.48ed1c66.svg";